import { get, writable } from "svelte/store";


const { subscribe, set, update } = writable({ added: [] });
const initObject = (state, name) => {
    state = state || {}
    if (!state[name]) state[name] = {
        upsert: [],
        delete: []
    }
    return state
}
export default {
    subscribe,
    upsert(name, data, isNewRow) {
        update((state) => {
            const newState = initObject(state, name)
            const upsertData = newState[name].upsert
            if (name == 'channels') data.language == data.language?.value || data.language 
            // check if exists
            var existingIndex = upsertData.findIndex(r => r.id == data.id)
            // console.log(state, existingIndex, data)
            if (existingIndex >= 0) {
                upsertData[existingIndex] = data
                return newState
            }
            else {
                upsertData.push(data)
                if (isNewRow) newState.added.push(data.id)
                return newState
            }


        })
    },
    delete(name, data, key = 'id') {
        update((state) => {
            const newState = initObject(state, name)
            function addDelete(item) {
                console.log(item);
                let id = item
                if (typeof item != 'string') id = id[key]
                // add to delete if not new upsert
                if (!state.added.includes(id)) newState[name].delete.push(id)
                else newState.added.filter(elm => elm != id)
                // filter out  from upsert
                newState[name].upsert = newState[name].upsert.filter(r => r.id != id)
            }
            if (Array.isArray(data)) data.forEach(addDelete)
            else addDelete(data)
            return newState
        })
    },
    added(id) {
        update((state) => {
            return { ...state, added: [...state.added, id] }
        })
    },
    remove(name) {
        if (!name) {
            set({ added: [] })
        }
        else {
            set((state) => {
                delete state[name]
                return state
            })
        }

    }



}